// extracted by mini-css-extract-plugin
module.exports = {"component":"EmailOptions_component__wJx_a","wrapper":"EmailOptions_wrapper__-VPOB"};